import axios from 'axios';

const instance = axios.create({
  baseURL: "https://nks.qravtojol.uz",
});

instance.interceptors.request.use(
    (config) => {
      const token = JSON.parse(localStorage.getItem('data'));
  
      if (token) {
        config.headers.Authorization =`${token}`;
      }
      return config;
    },
  
    (error) => console.log(error)
  );
  
  instance.interceptors.response.use((response) => response.data);

export default instance;
